package top.wcpe.allincore.ui.runtime.element

import kotlin.jvm.JvmStatic

/**
 * 通用容器控件，无默认布局方向。
 */
class Box private constructor() : UIElement<Box>() {

    protected override fun self(): Box = this

    companion object {
        /** 创建一个通用容器实例。 */
        @JvmStatic
        fun create(): Box = Box()
    }
}
